// @ts-check

import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

/**
 * @type {() => neptune.payment.ICreditCardState}
 */
export const state = () => ({
  invoiceDetails: {
    amount: 0,
    invoice: {
      createdAt: null,
      createdByUserId: null,
      invoiceId: null,
      policyId: null,
      policyTransactionId: null,
      updatedAt: null,
      updatedByUserId: null
    },
    invoiceItems: [],
    isPaid: false
  },
  // stripe payment intent
  stripePaymentData: null,
  // client secret
  paymentIntentToken: null,
  // saved payment methods
  paymentMethodData: []
});

/** @type {import('vuex').Module<any,any>} */
const mod = {
  state,
  actions,
  getters,
  mutations,
  namespaced: true
};

export default mod;
